import type { MarketVariants } from '@/lib/i18n'

export type Slide2BridgeCopy = { headline: string; sub: string }

export const copy: MarketVariants<Slide2BridgeCopy> = {
  US: {
    // "defense" auto-spells to "defence" on the Qatar face via useSlideCopy.
    headline: 'You’ve learned the Pause and Verify defense.',
    sub: 'Now let’s look at the warning signs that should trigger it.',
  },
  ar: {
    headline: 'تعلّمت أسلوب الحماية "توقّف وتحقّق".',
    sub: 'والآن لنتعرّف على علامات التحذير التي يجب أن تدفعك إلى تطبيقه.',
  },
}
